import { render, staticRenderFns } from "./checkPhoto.vue?vue&type=template&id=5f9066c8"
import script from "./checkPhoto.vue?vue&type=script&lang=js"
export * from "./checkPhoto.vue?vue&type=script&lang=js"
import style0 from "./checkPhoto.vue?vue&type=style&index=0&id=5f9066c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports